import React, { useState, useEffect } from 'react';

import { FormCheckbox } from "components";

import { deepCloneObject, getArrayLength, getObjectLength, getObjectPropertyValue, getStringUniqueId, isArray, isArrayNotEmpty, isFunction, isNotNullUndefined, isNumberValid, isObjectEmpty, isObjectNotEmpty } from 'functions';


export function useCheckboxes(props) {
    const { 
		totalSelectionLimit,
		dataList: dataList_props,
		initSelectedIndexes,
	} = props;	

	let init_selectedIndexes = {};
	if (isArrayNotEmpty(initSelectedIndexes)) {
		initSelectedIndexes.map((index) => {
			init_selectedIndexes[index] = true;
		})
	}


	// States

	const [dataList, setDataList] = useState(dataList_props);

	const [isMainCheckboxChecked, setIsMainCheckboxChecked] = useState(false);
	const [isMainCheckboxIndeterminate, setIsMainCheckboxIndeterminate] = useState(false);
	const [isCheckboxCheckedLimitReached, setIsCheckboxCheckedLimitReached] = useState(false);

	const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
	const [selectedIndexes, setSelectedIndexes] = useState(init_selectedIndexes);

	const [mainCheckboxID] = useState(getStringUniqueId("mainCheckbox"));
	const [checkboxIDList, setCheckboxIDList] = useState([]);

	const [isResetRequired, setIsResetRequired] = useState();

	useEffect(() => {
		if (isArray(dataList_props)) {
			setDataList(dataList_props);
		}
	}, [JSON.stringify(dataList_props)]);

	// Reset the checkbox id list
	useEffect(() => {
		if (isArrayNotEmpty(dataList)) {

			let init_checkboxIDList = dataList.map((data, idx) => {
				let checkboxID = getStringUniqueId("subcheckbox");
				if (getArrayLength(checkboxIDList, 0) > idx) 
					checkboxID = checkboxIDList[idx]?.checkboxID;

				return {
					checkboxID,
					isDisabled: data?.isDisabled
				}
			});
			setCheckboxIDList(init_checkboxIDList);
		}
		else setCheckboxIDList([]);
	}, [JSON.stringify(dataList)]);

	// Initialize seelcted checkboxes
	function initSelectedCheckboxes() {
		if (isArrayNotEmpty(dataList) &&
			isArrayNotEmpty(checkboxIDList)) {

			setSelectedIndexes({});

			let selectedCheckboxes_new = {};
			if (isArrayNotEmpty(initSelectedIndexes)) {
				initSelectedIndexes.map((indexNum, idx) => {

					let checkboxId = checkboxIDList[indexNum]?.checkboxID;
					selectedCheckboxes_new[checkboxId] = dataList[indexNum];
					handle_subAffectMainCheckbox(selectedCheckboxes_new);
				});
			}
			else handle_subAffectMainCheckbox([]);

			let totalSelected = getObjectLength(selectedCheckboxes_new);
			if (totalSelectionLimit <= totalSelected) {
				setIsCheckboxCheckedLimitReached(true);
			}

			setSelectedCheckboxes(selectedCheckboxes_new);
		}
	}
	useEffect(() => {
		if (isObjectEmpty(selectedCheckboxes))
			initSelectedCheckboxes();
	}, [JSON.stringify(checkboxIDList), JSON.stringify(initSelectedIndexes)]);

	// Update parent states
	useEffect(() => {
		if (props.updateParentState && 
			isArrayNotEmpty(checkboxIDList)) {
			props.updateParentState(reformatSelectedData());
		}
	}, [JSON.stringify(selectedCheckboxes)]);

	function handleSubCheckboxSelection(checkboxID, isChecked, data, index) {
		let selectedCheckboxes_new = deepCloneObject(selectedCheckboxes);

		if (isChecked) {
			selectedCheckboxes_new[checkboxID] = data;
			setSelectedCheckboxes(selectedCheckboxes_new);

			let totalSelected = getObjectLength(selectedCheckboxes_new);
			if (totalSelectionLimit <= totalSelected) {
				setIsCheckboxCheckedLimitReached(true);
			}

			// Update selected indexes
			let newObj = deepCloneObject(selectedIndexes);
			newObj[index] = true;
			setSelectedIndexes(newObj);
		}
		else {
			delete selectedCheckboxes_new[checkboxID];
			setSelectedCheckboxes(selectedCheckboxes_new);

			let totalSelected = getObjectLength(selectedCheckboxes_new);
			if (totalSelectionLimit > totalSelected) {
				setIsCheckboxCheckedLimitReached(false);
			}

			// Update selected indexes
			let newObj = deepCloneObject(selectedIndexes);
			delete newObj[index];
			setSelectedIndexes(newObj);
		}

		handle_subAffectMainCheckbox(selectedCheckboxes_new);
	}
	function handle_subAffectMainCheckbox(selectedCheckboxes_new) {
		let totalSelected = getObjectLength(selectedCheckboxes_new);
		let totalOriginalData = getArrayLength(dataList, 0);
		if ((totalSelected < totalOriginalData) &&
			(totalSelected > 0)) {
			setIsMainCheckboxIndeterminate(true);
			setIsMainCheckboxChecked(false);
		}
		else if (totalSelected == 0) {
			setIsMainCheckboxIndeterminate(false);
			setIsMainCheckboxChecked(false);
		}
		else if ((totalSelected == totalOriginalData)) {
			setIsMainCheckboxIndeterminate(false);
			setIsMainCheckboxChecked(true);
		}
	}
	function handleMainCheckboxSelection(isChecked) {
		setIsMainCheckboxChecked(isChecked);
		setIsMainCheckboxIndeterminate(false);

		let selectedCheckboxes_new = {};
		if (isChecked) {
			if (isArrayNotEmpty(checkboxIDList)) {
				let newObj = {};
				checkboxIDList.map((obj, idx) => {
					selectedCheckboxes_new[obj?.checkboxID] = dataList[idx]
					newObj[idx] = true;
				});

				setSelectedIndexes(newObj);
			}

			setSelectedCheckboxes(selectedCheckboxes_new);

			if (isFunction(props.onMainCheckboxSelection))
				props.onMainCheckboxSelection(selectedCheckboxes_new);
		}
		else {
			setSelectedCheckboxes({});
			setSelectedIndexes({});

			if (isFunction(props.onMainCheckboxDeselection))
				props.onMainCheckboxDeselection();
		}
    }
    
    function MainCheckbox(props) {
		const { 
			className, iconClassName, 
			isDisabled, disabledMsg,
		
			labelClassName, checkboxLabel
		} = props;

		return (
            <FormCheckbox
                checkboxClassName={className}
                checkboxIconClassName={iconClassName}
                isCheckboxDisabled={isDisabled || isNumberValid(totalSelectionLimit)}
				disabledMsg={disabledMsg}

				labelClassName={labelClassName}
				checkboxLabel={checkboxLabel}

                checkboxID={mainCheckboxID}
				mainCheckboxID={mainCheckboxID}
				
				isResetRequired={isResetRequired}
    
                isMainCheckboxChecked={isMainCheckboxChecked}
                isMainCheckboxIndeterminate={isMainCheckboxIndeterminate}
				handleCheckboxSelectionMain={(checkboxID, isChecked) => { handleMainCheckboxSelection(isChecked); }}
				
				isDecoration_lightBackground
            />
        );
	}

	function subCheckboxes(props) {
		const { className, iconClassName, isDisabled: isAllDisabled, disabledList, disabledMsg } = props;
		
		let isAllDisabled_validated = isNotNullUndefined(isAllDisabled)? isAllDisabled: false;
		let isCheckboxCheckedLimitReached_validated = isNotNullUndefined(isCheckboxCheckedLimitReached)? isCheckboxCheckedLimitReached: false;

		let subCheckboxes = [];
		if (isArrayNotEmpty(checkboxIDList)) {
			subCheckboxes = checkboxIDList.map((checkboxObj, idx) => {
				let isSelected = getObjectPropertyValue(selectedCheckboxes, checkboxObj?.checkboxID + "");
				let data = isArrayNotEmpty(dataList)? dataList[idx]: "";

				let isCheckboxDisabled = (isAllDisabled_validated && (!isCheckboxCheckedLimitReached_validated)) ||
					(isAllDisabled_validated && isCheckboxCheckedLimitReached_validated && !isSelected);

				if (isArrayNotEmpty(disabledList)) {
					isCheckboxDisabled = disabledList[idx];
				}

				return (
					<FormCheckbox
						checkboxClassName={className}
						isCheckboxDisabled={isCheckboxDisabled || checkboxObj?.isDisabled}
						isCheckboxCheckedDefault={isSelected}
						disabledMsg={disabledMsg}
						
						checkboxIconClassName={iconClassName}
	
						checkboxID={checkboxObj?.checkboxID}

						isResetRequired={isResetRequired}
	
						mainCheckboxID={mainCheckboxID}
						isMainCheckboxChecked={isMainCheckboxChecked}
						isMainCheckboxIndeterminate={isMainCheckboxIndeterminate}
	
						handleCheckboxSelectionSub={(checkboxID, isChecked) => { handleSubCheckboxSelection(checkboxID, isChecked, data, idx); }}

						isDecoration_lightBackground
					/>
				)
			})
		}
		return subCheckboxes;
	}

	function reset() {
		initSelectedCheckboxes();
		setIsResetRequired(true);
	}
	useEffect(() => {
        reset();
    }, [JSON.stringify(dataList)]);
	useEffect(() => {
		if (isResetRequired) setIsResetRequired(false);
	}, [isResetRequired]);
	
	function reformatSelectedData() {
		let selectedData = [];
		if (isObjectNotEmpty(selectedCheckboxes)) {
			for (const checkboxID in selectedCheckboxes) {
				if (selectedCheckboxes.hasOwnProperty(checkboxID)) {
					const data = selectedCheckboxes[checkboxID];
					selectedData.push(data);
				}
			}
		}
		return selectedData;
	}

    return {
        MainCheckbox,
		subCheckboxes,
		
		selectedData: reformatSelectedData(),
		selectedIndexes,

		isMainCheckboxChecked, isMainCheckboxIndeterminate, isCheckboxCheckedLimitReached, 
		checkboxIDList, isResetRequired,

		reset
    }
}